"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.user.exceeded': 'User limit reached. Upgrade your plan to add more users.',
    'limits.user.limitReached': 'User limit: {limit} (upgrade to add more)',
};
